export default __webpack_public_path__ + "static/media/07-Mohammed-Mahfoudh.b097aadf.png";